<template>
  <window
    ref="window"
    size="mdlg"
    :show-head="false"
    @show="onShow"
    @opened="onOpened"
    @closed="onClosed"
    class="window--full-height"
  >
    <div class="exist_code" v-if="existCode && !sameCode">
      <h2>Dieser QR-Code wird schon verwendet.</h2>
    </div>
    <div class="exist_code same_code" v-if="existCode && sameCode">
      <h2>Dieser QR-Code ist derselbe.</h2>
    </div>
    <div class="exist_code same_code d-flex justify-content-between" v-if="sameCodeApi">
      <h2>Der eben erfasste QR Code stimmt nicht mit dem bisherigem Code dieser Position überein. Bist du auf Position #{{POSITION_ID}}#. Soll der QR Code ersetzt werden?</h2>
      <div class="d-flex justify-content-between">
        <button
          class="btn btn-secondary"
          @click="replaceCode()"
        >
          Ja
        </button>
        <button
          class="btn btn-secondary"
          @click="wHide()"
        >
          Nein
        </button>
      </div>
    </div>
    <div class="qrscanner__video-container">
      <qrcode-stream
        :worker="Worker"
        ref="video"
        @init="onInit"
        :track="track"
        @decode="onDecode"
      >
        <div class="loading-indicator" v-if="loadingC">Loading...</div>
      </qrcode-stream>

      <div
        v-if="result && !existCode"
        class="qrscanner__success"
        :style="scanningAreaBoxStyle"
      >
        <img :src="icon('check-circle-green.svg')" width="70" height="70" />
      </div>
    </div>
    <div>
      <input class="p-1" id="qrcode_inp" type="text" v-model="codeInp" />
      <button
        :disabled="loading"
        class="btn btn-secondary mt-mdsm"
        @click="saveCode"
      >
        {{ job_report ? "Speichern" : "Manuelle Suche" }}
      </button>
    </div>
    <div
      slot="footer"
      class="d-flex justify-content-between align-items-center"
      slot-scope="window"
    >
      <span>Richten Sie die Kamera auf den QR-Code</span>

      <button
        class="btn btn-secondary"
        @click="
          window.hide();
          existCode = false;
        "
      >
        Abbrechen
      </button>
    </div>
  </window>
</template>

<script>
import Worker from "../jsqr-copy";
export default {
  provide: {
    windowId: "qrScanner",
  },
  props: {
    job_report: {
      type: Boolean,
      default: false,
    },
    code_prop: {
      type: String,
      default: "",
    },
    part_id: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      Worker,
      result: null,
      POSITION_ID: null,
      codeInp: "",
      loading: false,
      loadingC: false,
      cameras: ["environment", "user"],
      activeCameraIndex: 0,
      scanningAreaBoxStyle: null,
      darkenLayersStyle: null,
      existCode: false,
      sameCode: false,
      sameCodeApi: false,
      track: this.paintOutline,
    };
  },
  watch: {
    code_prop() {
      this.setCode();
    },
  },
  created() {
    this.setCode();
  },
  beforeDestroy() {
    this.stopScanning();
  },
  computed: {
    camera() {
      return this.cameras[this.activeCameraIndex];
    },
  },
  methods: {
    async onInit(promise) {
      this.loadingC = true;

      try {
        await promise;
      } catch (error) {
        console.error(error);
      } finally {
        this.loadingC = false;
      }
    },
    setCode() {
      if (this.code_prop) {
        const base = "https://s.scando.ch/?id=";
        let code = this.code_prop.replace(base, "");
        this.codeInp = code;
        this.codeInpApi = this.code_prop;
      } else {
        this.codeInp = "";
      }
    },

    paintOutline(detectedCodes, ctx) {
      for (const detectedCode of detectedCodes) {
        const [firstPoint, ...otherPoints] = detectedCode.cornerPoints;

        ctx.strokeStyle = "red";

        ctx.beginPath();
        ctx.moveTo(firstPoint.x, firstPoint.y);
        for (const { x, y } of otherPoints) {
          ctx.lineTo(x, y);
        }
        ctx.lineTo(firstPoint.x, firstPoint.y);
        ctx.closePath();
        ctx.stroke();
      }
    },
    saveCode() {
      if (this.codeInp) {
        this.existCode = false;
        const base = "https://s.scando.ch/?id=";

        let codeInp = this.codeInp.replace(base, "");
        let code = base + codeInp;
        this.result = {
          code: code,
          code_api: codeInp,
        };
        this.checkIfCode();
      }
    },

    async onDecode(decodedString) {
      try {
        const stringDecode = await decodedString;

        if (stringDecode) {
          requestAnimationFrame(async () => {
            this.existCode = false;
            this.result = {
              code: stringDecode,
              code_api: stringDecode,
            };
            this.checkIfCode();
          });
        }
      } catch (error) {
        // ...
      }
      // ...
    },
    async checkIfCode() {
      this.loading = true;
      if (this.result.code) {
        if (this.job_report) {
          if (!navigator.onLine) {
            const code = await this.findOfflineQrCode(this.result.code);
            this.loading = false;
            if (code && code.data) {
              console.log(code, 'code offline')
              if (code.part_id == this.part_id) {
                this.sameCode = true;
                this.existCode = false;
                this.result = { ...this.result, sameCode: this.sameCode };
                window.setTimeout(() => {
                  this.$refs.window.hide(this.result);
                }, 1000);
              } else {
                this.sameCode = false;
                this.sameCodeApi = false;
                this.existCode = true;
              }
            } else {
              this.existCode = false;
              this.sameCode = false;
              this.sameCodeApi = false;

              window.setTimeout(() => {
                this.$refs.window.hide(this.result);
              }, 1000);
            }
          } else {
            const code = await this.$store.dispatch(
              "jobs/respondQrCodeRequests",
              {
                code: this.result.code,
                part_id: this.part_id,
                code_api: this.result.code_api
              }
            );
            this.loading = false;
            if (code.data['same_code']) {
              this.sameCodeApi = !code.data['api_code']
              this.sameCode = true;
              this.existCode = false;
              this.result = { ...this.result, sameCode: this.sameCode };
              if(code.data['api_code']){
                window.setTimeout(() => {
                  this.$refs.window.hide(this.result);
                }, 1000);
              }
            } else if (code.data && !code.data['api_code']) {
              this.existCode = false;
              this.sameCode = false;
              this.sameCodeApi = !code.data['api_code']
              this.POSITION_ID = code.data.location_floor + ' ' + code.data.location_position
            }  else if (code.data ) {
              this.existCode = true;
              this.sameCode = false;
              this.sameCodeApi = !code.data['api_code']
            }else {
              this.existCode = false;
              this.sameCode = false;
              this.sameCodeApi = false;

              window.setTimeout(() => {
                this.$refs.window.hide(this.result);
              }, 1000);
            }
          }
        } else {
          this.loading = false;

          window.setTimeout(() => {
            this.$refs.window.hide(this.result);
          }, 1000);
        }
      }
    },
    onShow() {
      this.result = null;
    },
    onOpened() {
      // this.startScanning(this.camera);
    },
    onClosed() {
      this.existCode = false;
      this.sameCodeApi = false;
      this.sameCode = false;
      this.codeInp = "";

      //   this.stopScanning();
    },
    async findOfflineQrCode(code) {
      let jobs = this.$store.state.jobs.persistSync;
      let jobs2 = this.$store.state.jobs.persistPut;
      jobs = jobs.concat(jobs2);
      let obj = null;
      jobs.forEach((x) => {
        x.parts.forEach((y) => {
          y.codes.forEach((z) => {
            if (z && z.code && z.code == code) {
              obj = { data: {} };
              obj.data.stauts = y.report ? y.report.status : null;
              obj.data.job_id = x.id;
              obj.data.part_id = y.id;
              return obj;
            }
          });
        });
      });
      if (obj != null) {
        return obj;
      } else {
        window.setTimeout(() => {
          this.$refs.window.hide(this.result);
        }, 1000);
      }
    },
    switchCamera() {
      this.activeCameraIndex =
        this.activeCameraIndex + 1 >= this.cameras.length
          ? 0
          : this.activeCameraIndex + 1;
    },

    getImage(image, location) {
      return new Promise((resolve, reject) => {
        const video = image.data;
        const canvas = document.createElement("canvas");

        canvas.width = video.width;
        canvas.height = video.height;

        canvas
          .getContext("2d")
          .drawImage(
            video,
            location.topLeftCorner.x,
            location.topLeftCorner.y,
            0,
            0,
            canvas.width,
            canvas.height
          );

        canvas.toBlob((blob) => resolve(blob));
      });
    },

    async onDetect(promise) {
      try {
        const {
          imageData, // raw image data of image/frame
          content, // decoded String
          location, // QR code coordinates
        } = await promise;

        if (content) {
          requestAnimationFrame(async () => {
            this.existCode = false;
            this.sameCode = false;
            this.sameCodeApi = false;
            this.result = {
              code: content,
              qrString: content,
              image: imageData.data,
            };
            if (this.result.code) {
              if (this.job_report) {
                if (!navigator.onLine) {
                  const code = await this.findOfflineQrCode(this.result.code);
                  if (code && code.data) {
                    if (code.part_id == this.part_id) {
                      this.sameCode = true;
                      this.existCode = false;
                    } else {
                      this.existCode = true;
                    }
                  } else {
                    this.existCode = false;
                    this.sameCode = false;

                    window.setTimeout(() => {
                      this.$refs.window.hide(this.result);
                    }, 1000);
                  }
                } else {
                  const code = await this.$store.dispatch(
                    "jobs/respondQrCodeRequests",
                    {
                      code: this.result.code,
                      part_id: this.part_id,
                      code_api: this.result.code_api
                    }
                  );
                  if (code.data['same_code']) {
                    this.sameCodeApi = !code.data['api_code']
                    this.sameCode = true;
                    this.existCode = false;
                  } else if (code.data) {
                    this.existCode = true;
                    this.sameCode = false;
                    this.sameCodeApi = !code.data['api_code']
                  } else {
                    this.existCode = false;
                    this.sameCode = false;

                    window.setTimeout(() => {
                      this.$refs.window.hide(this.result);
                    }, 1000);
                  }
                }
              } else {
                window.setTimeout(() => {
                  this.$refs.window.hide(this.result);
                }, 1000);
              }
            }
          });
        }
      } catch (error) {
        // ...
      }
    },
    replaceCode(){
      window.setTimeout(() => {
        this.$refs.window.hide(this.result);
      }, 1000);
    },
    wHide(){
      window.setTimeout(() => {
        this.$refs.window.hide();
      }, 100);
    }
  },
};
</script>

<style lang="scss">
.exist_code {
  margin: 1rem 0;
  color: red;
  &.same_code {
    color: $state-ok;
  }
}
.qrscanner {
  &__video-container {
    position: relative;
    line-height: 0;
    max-height: 60vh;
  }

  &__video {
    flex: 1 0 0;
    max-width: 100%;
    max-height: 100%;
  }

  &__darken-layers {
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;

    &__layer {
      position: absolute;
      background-color: rgba(0, 0, 0, 0.6);

      &--left,
      &--right {
        top: 0;
        bottom: 0;
      }
      &--left {
        left: 0;
      }
      &--right {
        right: 0;
      }

      &--top {
        top: 0;
      }
      &--bottom {
        bottom: 0;
      }
    }
  }

  &__scanning-area-box {
    position: absolute;

    &__corner {
      $corner-border-width: 5px;
      position: absolute;
      border-color: $white;
      border-width: $corner-border-width;
      width: 30%;
      height: 30%;

      &--lt {
        left: -#{$corner-border-width};
        top: -#{$corner-border-width};
        border-left-style: solid;
        border-top-style: solid;
      }

      &--rt {
        right: -#{$corner-border-width};
        top: -#{$corner-border-width};
        border-right-style: solid;
        border-top-style: solid;
      }

      &--rb {
        right: -#{$corner-border-width};
        bottom: -#{$corner-border-width};
        border-right-style: solid;
        border-bottom-style: solid;
      }

      &--lb {
        left: -#{$corner-border-width};
        bottom: -#{$corner-border-width};
        border-left-style: solid;
        border-bottom-style: solid;
      }
    }
  }

  &__success {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba($state-ok, 0.3);
    animation: fadeIn 0.5s linear 0s 1;
    animation-fill-mode: forwards;
    width: 100%;
    height: 100%;
    top: 0;
  }
}
</style>